/**
 * Utility functions for handling arena-related data
 */

export const getArenaSlug = (): string | null => {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return null;
  }
  return localStorage.getItem('arenaSlug') ?? localStorage.getItem('sporto_slug');
};

export const setArenaSlug = (slug: string): void => {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return;
  }
  localStorage.setItem('arenaSlug', slug);
  localStorage.setItem('sporto_slug', slug);
};

export const clearArenaSlug = (): void => {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return;
  }
  localStorage.removeItem('arenaSlug');
};

export const requireArenaSlug = (): string => {
  const slug = getArenaSlug();
  if (!slug) {
    throw new Error(
      'Arena slug not found. Please ensure you are logged in and have selected an arena.'
    );
  }
  return slug;
};
